module.exports = __webpack_public_path__ + "img/Group _27911.bf8b1c0d.svg";